import script from "./UserMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMessage.vue?vue&type=script&setup=true&lang=js"

import "./UserMessage.vue?vue&type=style&index=0&id=60d7a401&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d7a401"]])

export default __exports__